<template>
  <div>
    <the-header />
    <div class="container">
      <h1>401 - Access denied</h1>
    </div>
  </div>
</template>
<script>
  import TheHeader from '@/common/TheHeader'

  /**
   * Component is shown when user hasn't access to route
   */
  export default {
    name: "AccessDenied",
    components: {
      TheHeader
    }
  }
</script>

<style scoped>

</style>
